import { render, staticRenderFns } from "./GridPagerCpt.vue?vue&type=template&id=c4163e20&scoped=true&"
import script from "./GridPagerCpt.vue?vue&type=script&lang=ts&"
export * from "./GridPagerCpt.vue?vue&type=script&lang=ts&"
import style0 from "./GridPagerCpt.vue?vue&type=style&index=0&id=c4163e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4163e20",
  null
  
)

export default component.exports